var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconStation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-station"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-station",
    clipPath: "url(#clip-icon-station)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M454.33,381.447q-.03.48-.03.96v-.96Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M780.023,629.5v.05h2.55C781.723,629.546,780.873,629.536,780.023,629.5Zm-323.4-249.16v.97c0-.32.01-.65.03-.97Zm-2.32,1.11v.96q0-.48.03-.96Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M456.65,380.337c-.02.32-.03.65-.03.97v-.97Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M438.823,777.116h-2.55v-.05C437.123,777.106,437.973,777.116,438.823,777.116Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M438.823,777.116h-2.55v-.05C437.123,777.106,437.973,777.116,438.823,777.116Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(1.447 0.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M792.433,294.176v93.57a16,16,0,0,1-16,16h-56a16,16,0,0,1-16-16v-93.57c0-26.95-22.37-48.87-49.87-48.87h-358.7c-27.5,0-49.88,21.92-49.88,48.87v356.3h309.71a9.95,9.95,0,0,1,9.95,9.95v111.56a9.942,9.942,0,0,1-9.95,9.94H70.553a8,8,0,0,1-8-8v-40.64a82.81,82.81,0,0,1,82.81-82.81h12.62v-356.3c0-75.47,61.86-136.87,137.88-136.87h358.7C730.583,157.306,792.433,218.706,792.433,294.176Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1898",
    "data-name": "Group 1898"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M957.946,573.905V810.652a48.83,48.83,0,0,1-53.823,53.517H655.086a48.061,48.061,0,0,1-52.827-52.377V498.665a49.547,49.547,0,0,1,55.609-55.5c52.931,0,105.861.168,158.826-.167,8.581,0,11.326,2.128,11.154,11.02-.582,27.664-.276,55.336-.205,83a33.535,33.535,0,0,0,37,36.832H947.68Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    d: "M951.8,539.067H870.274c-4.737,0-8.169-.754-8.135-6.863v-79.33a12.123,12.123,0,0,1,.823-3.436Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStation);
export default __webpack_public_path__ + "static/media/icon-station.40230b7d01ae9aeb3d7517b9f080ba08.svg";
export { ForwardRef as ReactComponent };